import { HStack } from "@chakra-ui/react"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import CompletionFeedbackDetail from "@pathwright/web/src/modules/completion/feedback/CompletionFeedbackDetail"
import pluralize from "pluralize"
import StepCommentFieldContainer from "./StepCommentFieldContainer"
import StepIncompleteBlocks from "./StepIncompleteBlocks"
import StepSkipped from "./StepSkipped"

const tPrefix = "step.incomplete"

const StepIncomplete = function (props) {
  const {
    step,
    completion,
    step_completion_error,
    is_completing_step,
    is_skipping_step,
    canComplete,
    onSkipStep,
    onCompleteStep,
    failed
  } = props

  const { t } = useTranslate()

  const pts = t(`${tPrefix}.${pluralize("pt", completion.userpoints_value)}`)

  let ptsLabel = `${completion.userpoints_value}${pts}`

  if (step.grading_type === "M") {
    ptsLabel = `${ptsLabel} ${t(`${tPrefix}.possible`)}`
  }

  return (
    <div className="step-incomplete-container">
      <StepCommentFieldContainer />
      {!failed && (
        <StepIncompleteBlocks step={step} canComplete={canComplete}>
          <SubmitButton
            onClick={onCompleteStep}
            isSubmitting={is_completing_step}
            submitFailure={step_completion_error}
            disabled={!canComplete || is_skipping_step}
            styleType="primary"
            size="large"
            ariaLabelledBy={"complete-step"}
          >
            {!canComplete && <Pathicon icon="lock" />}
            {!canComplete && <span> </span>}
            <Text
              id="complete-step"
              lines={1}
              style={{ color: "inherit", fontWeight: "inherit" }}
            >
              {t(`${tPrefix}.complete_step`)}
            </Text>
          </SubmitButton>
        </StepIncompleteBlocks>
      )}
      {!step.is_required && (
        <HStack className="skip-step-prompt" spacing={1}>
          <span>{t(`${tPrefix}.or`)}</span>
          <SubmitButton
            hideSuccess
            submitting={is_skipping_step}
            submitFailure={step_completion_error}
            disabled={is_completing_step}
            onClick={onSkipStep}
            styleType="inline"
            className="skip-step"
            label={t(`${tPrefix}.skip_it`)}
          />
        </HStack>
      )}
      {!failed && (
        <div className="step-complete-stats">
          {completion.is_skipped && (
            <span>
              <StepSkipped stepId={step.id} />
            </span>
          )}
          {completion.userpoints_value > 0 && (
            <span className="path-step-points">
              <span className="path-step-points-amount">{ptsLabel}</span>
            </span>
          )}
          {completion.requires_api_completion && (
            <span className="step-external-api-completion">
              {t("This step may only be completed externally.")}
            </span>
          )}
          <span>
            <CompletionFeedbackDetail stepId={step.id} />
          </span>
        </div>
      )}
    </div>
  )
}

StepIncomplete.displayName = "StepIncomplete"

export default StepIncomplete
